import { doc, setDoc, getDoc, getDocs, collection } from "firebase/firestore";
import { db } from "../firebaseConfig";

export const createParticipantFirebase = async (resUser) => {
  const newParticipant = {
    id: resUser.id,
    name: resUser.name,
    email: resUser.email,
    age: resUser.age ? resUser.age : "",
    sex: resUser.sex ? resUser.sex : "",
    social: resUser.social ? resUser.social : "",
    education: resUser.education ? resUser.education : "",
    meds: resUser.meds ? resUser.meds : "",
    group: resUser.group ? resUser.group : "",
    trialDay: resUser.trialDay ? resUser.trialDay : 1,
    phase: resUser.phase ? resUser.phase : 0,
    DASS: resUser.DASS ? resUser.DASS : [],
    DASSdep: resUser.DASSdep ? resUser.DASSdep : 0,
    DASSanx: resUser.DASSanx ? resUser.DASSanx : 0,
    DASSstr: resUser.DASSstr ? resUser.DASSstr : 0,
    WordVal: resUser.WordVal ? resUser.WordVal : [],
    Trial1: resUser.Trial1 ? resUser.Trial1 : [],
    Trial1attempts: resUser.Trial1attempts ? resUser.Trial1attempts : 0,
    Trial1score: resUser.Trial1score ? resUser.Trial1score : 0,
    Test1: resUser.Test1 ? resUser.Test1 : [],
    Test1score: resUser.Test1score ? resUser.Test1score : 0,
    Trial2: resUser.Trial2 ? resUser.Trial2 : [],
    Trial2attempts: resUser.Trial2attempts ? resUser.Trial2attempts : 0,
    Trial2score: resUser.Trial2score ? resUser.Trial2score : 0,
    Test2: resUser.Test2 ? resUser.Test2 : [],
    Test2score: resUser.Test2score ? resUser.Test2score : 0,
    sessionTime: resUser.sessionTime ? resUser.sessionTime : 0,
    commitmentAgreement: resUser.commitmentAgreement
      ? resUser.commitmentAgreement
      : 0,
    createdAt: resUser.createdAt ? resUser.createdAt : 0,
  };
  await setDoc(doc(db, "wordMood2", resUser.id), newParticipant);

  console.log(`mood ${resUser.name} created`);
};

export const getParticipantFirebase = async (id) => {
  const docRef = doc(db, "wordMood2", id);
  const docSnap = await getDoc(docRef);
  if (docSnap.exists()) {
    console.log(`mood ${docSnap.data().name} loaded`);
    return docSnap.data();
  } else {
    console.log("No such document");
  }
};

export const getResDataFirebase = async () => {
  const docRef = collection(db, "wordMood2");
  const docSnap = await getDocs(docRef);
  if (docSnap) {
    return docSnap.docs.map((doc) => ({ ...doc.data() }));
  } else {
    console.log("No such document");
  }
};
